package com.dotdrives.web.pages.settings

import com.dotdrives.client.SettingsClient
import com.dotdrives.model.goalProgress
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.cancel
import kotlinx.coroutines.launch
import kotlinx.coroutines.awaitCancellation
import kotlinx.datetime.LocalDate
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import react.FC
import react.Props
import react.dom.html.ReactHTML.div
import react.useEffect
import react.useState
import web.cssom.ClassName
import kotlin.time.Clock

external interface GoalProgressLineProps : Props {
    var orgId: String; var amount: Double?; var start: String?; var end: String?
    var kind: String; var goalId: String
}

/** Each row uses its own inclusive goal dates, so its pace never inherits the Reports window. */
val GoalProgressLine = FC<GoalProgressLineProps> { props ->
    val (copy, setCopy) = useState("Loading net giving…")
    useEffect(props.orgId, props.kind, props.goalId, props.start, props.end, props.amount) {
        val scope = MainScope()
        scope.launch {
            val today = Clock.System.now().toLocalDateTime(TimeZone.UTC).date
            runCatching {
                SettingsClient().goalProgress(props.orgId, props.kind, props.goalId)
            }.onSuccess { raised ->
                val progress = goalProgress(raised, props.amount, props.start?.let(LocalDate::parse), props.end?.let(LocalDate::parse), today)
                val percent = progress.percent?.let { " · ${it.toInt()}%" }.orEmpty()
                val pace = progress.paceDifference?.let { " · ${if (it >= 0) "ahead" else "behind"} ${formatBudgetMoney(kotlin.math.abs(it))} pace" }.orEmpty()
                setCopy("${formatBudgetMoney(raised)} raised$percent$pace")
            }.onFailure { setCopy("Net giving unavailable. Retry by refreshing settings.") }
        }
        try { awaitCancellation() } finally { scope.cancel() }
    }
    div { className = ClassName("settings-goal-progress"); +copy }
}

/** Pure formatting for the unified list: loading one row never starts a network request. */
fun goalProgressCopy(batch: com.dotdrives.model.GoalsProgress?, failed: Boolean, kind: String, id: String,
    amount: Double?, start: String?, end: String?): String {
    if (failed) return "Net giving unavailable. Retry by refreshing settings."
    if (batch == null) return "Loading net giving…"
    if (!batch.financialVisible) return "Net giving hidden for your role."
    val raised = batch.progress.firstOrNull { it.kind == kind && it.id == id }?.raised
        ?: return "Net giving unavailable. Retry by refreshing settings."
    val today = Clock.System.now().toLocalDateTime(TimeZone.UTC).date
    val progress = goalProgress(raised, amount, start?.let(LocalDate::parse), end?.let(LocalDate::parse), today)
    val percent = progress.percent?.let { " · ${it.toInt()}%" }.orEmpty()
    val pace = progress.paceDifference?.let { " · ${if (it >= 0) "ahead" else "behind"} ${formatBudgetMoney(kotlin.math.abs(it))} pace" }.orEmpty()
    return "${formatBudgetMoney(raised)} raised$percent$pace"
}
